import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import Paginate from '../components/Paginate';
import Message from '../components/Message';
import Loading from '../components/Loading';
import {
  listProducts,
  deleteProduct,
  createProduct,
} from '../actions/productActions';
import { PRODUCT_CREATE_RESET } from '../constants/productConstants';

const ProductsListPage = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const pageNumber = match.params.pageNumber || 1;

  const productsList = useSelector((state) => state.productsList);
  const { loading, error, products, page, pages, keyword } = productsList;

  const productDelete = useSelector((state) => state.productDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = productDelete;

  const productCreate = useSelector((state) => state.productCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    product: createdProduct,
  } = productCreate;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch({ type: PRODUCT_CREATE_RESET });

    if (!userInfo.isAdmin) {
      history.push('/login');
      dispatch(listProducts());
    }
    if (successCreate) {
      history.push(`/admin/product/${createdProduct._id}/edit`);
    } else {
      dispatch(listProducts('', pageNumber)); // keyword set to empty ''
    }
  }, [
    dispatch,
    userInfo,
    history,
    successDelete,
    successCreate,
    createdProduct,
    pageNumber,
  ]);

  const deleteHandler = (product) => {
    if (
      window.confirm(
        `Are you sure to delete product "${product.name}" with id # ${product._id}?`
      )
    ) {
      dispatch(deleteProduct(product._id));
    }
  };
  const createProductHandler = (product) => {
    dispatch(createProduct());
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>Products List</h1>
        </Col>
        <Col>
          <Button className='my-3' onClick={createProductHandler}>
            <i className='fas fa-plus'></i> Create Product
          </Button>
        </Col>
        <Col>
          <Paginate
            page={page}
            pages={pages}
            keyword={keyword ? keyword : ''}
            isAdmin={true}
          />
        </Col>
      </Row>
      {loadingDelete && <Loading />}
      {errorDelete && <Message variant='danger'>{errorDelete}</Message>}
      {loadingCreate && <Loading />}
      {errorCreate && <Message variant='danger'>{errorCreate}</Message>}
      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>PRICE</th>
                <th>UNIT PRICE</th>
                <th>CATEGORY</th>
                <th>BRAND</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product._id}>
                  <td>{product._id}</td>
                  <td>{product.name}</td>
                  <td>Rp{product.price}</td>
                  <td>/{product.priceUnit}</td>
                  <td>{product.category}</td>
                  <td>{product.brand}</td>
                  <td>
                    <LinkContainer to={`/admin/product/${product._id}/edit`}>
                      <Button variant='light' className='btn-sm'>
                        <i className='fas fa-edit'></i>
                      </Button>
                    </LinkContainer>{' '}
                    &nbsp;{' '}
                    <LinkContainer to={`/products/${product._id}`}>
                      <Button
                        variant='light'
                        className='btn btn-txt inline-block'
                      >
                        <i className='fa fa-eye'></i>
                      </Button>
                    </LinkContainer>{' '}
                    &nbsp;{' '}
                    <Button
                      variant='danger'
                      className='btn-sm'
                      onClick={() => deleteHandler(product)}
                    >
                      <i className='fas fa-trash'></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};

export default ProductsListPage;
